import { Modal } from '@dynamika-shared/ui/Modal/Modal';
import { TextArea } from '@dynamika-shared/ui/TextArea/TextArea';
import { FC, useEffect } from 'react';
import { Alert } from 'antd';
import { Attention } from '@dynamika-shared/ui/icons';
import { Controller, useForm } from 'react-hook-form';

type UnlockVisitPositionModalProps = {
  onCancel: () => void;
  onOk: (reason: string) => void;
  showModal: boolean;
};
export const UnlockVisitPositionModal: FC<UnlockVisitPositionModalProps> = ({
  onCancel,
  onOk,
  showModal,
}) => {
  const {
    control,
    formState: { isValid, isDirty },
    getValues,
    reset,
  } = useForm({ defaultValues: { reason: '' } });
  const submit = () => {
    onOk(getValues().reason);
  };
  useEffect(() => {
    return () => {
      reset();
    };
  }, [showModal]);
  return (
    <Modal
      zIndex={9999}
      width={480}
      onCancel={onCancel}
      onOk={submit}
      okProps={{ disabled: !isValid || !isDirty }}
      okText='Unlock'
      open={showModal}
      title='Unlock Visit Position'
      titleClassName={'text-left'}
      maskClosable={false}
    >
      <Alert
        className={'border-honoluluBlue border-opacity-40 bg-aliceBlue p-2'}
        showIcon
        icon={<Attention width={16} />}
        message={<span className={'text-1424 font-semibold'}>Attention</span>}
        description={
          <div className={'text-1424 font-medium -mt-1'}>
            If any task definitions have already been executed, the system will
            reject the unlock.
          </div>
        }
      />
      <div className={'mt-3'}>
        <Controller
          name='reason'
          control={control}
          rules={{ required: true, minLength: 3 }}
          render={({ field }) => (
            <TextArea
              {...field}
              label={'Reason'}
              placeholder={'Unlock Reason'}
              className='!resize-none'
              rows={4}
              maxLength={700}
            />
          )}
        />
      </div>
    </Modal>
  );
};
